import { BREAKPOINTS } from "@/globals";
import { Link } from "@tanstack/react-router";
import styled from "styled-components";
import { type_f } from "@/theme/typography";

const steps = [
	{
		name: "Shape",
		route: "/step-1",
		icon: () => (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
				<path d="M315.4 15.5C309.7 5.9 299.2 0 288 0s-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2s16.3 16.2 27.8 16.2l192 0c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160zM288 312l0 144c0 22.1 17.9 40 40 40l144 0c22.1 0 40-17.9 40-40l0-144c0-22.1-17.9-40-40-40l-144 0c-22.1 0-40 17.9-40 40zM128 512a128 128 0 1 0 0-256 128 128 0 1 0 0 256z" />
			</svg>
		),
	},
	{
		name: "Doors",
		route: "/step-2",
		icon: () => (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
				<path d="M0 80c0 26.5 21.5 48 48 48l16 0 0 64 64 0 0-64 96 0 0 64 64 0 0-64 96 0 0 64 64 0 0-64 16 0c26.5 0 48-21.5 48-48l0-66.6C512 6 506 0 498.6 0c-1.7 0-3.4 .3-5 1l-49 19.6C425.7 28.1 405.5 32 385.2 32L126.8 32c-20.4 0-40.5-3.9-59.4-11.4L18.4 1c-1.6-.6-3.3-1-5-1C6 0 0 6 0 13.4L0 80zM64 288l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0 0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0z" />
			</svg>
		),
	},
	{
		name: "Pillars",
		route: "/step-3",
		icon: () => (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M201 10.3c14.3-7.8 31.6-7.8 46 0L422.3 106c5.1 2.8 8.3 8.2 8.3 14s-3.2 11.2-8.3 14L231.7 238c-4.8 2.6-10.5 2.6-15.3 0L25.7 134c-5.1-2.8-8.3-8.2-8.3-14s3.2-11.2 8.3-14L201 10.3zM23.7 170l176 96c5.1 2.8 8.3 8.2 8.3 14l0 216c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8 .3L25 423.1C9.6 414.7 0 398.6 0 381L0 184c0-5.6 3-10.9 7.8-13.8s10.9-3 15.8-.3zm400.7 0c5-2.7 11-2.6 15.8 .3s7.8 8.1 7.8 13.8l0 197c0 17.6-9.6 33.7-25 42.1L263.7 510c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8l0-216c0-5.9 3.2-11.2 8.3-14l176-96z"/></svg>
		),
	},
	{
		name: "Materials",
		route: "/step-4",
		icon: () => (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M162.4 6c-1.5-3.6-5-6-8.9-6l-19 0c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6L48 0C21.5 0 0 21.5 0 48L0 224l0 22.4L0 256l9.6 0 364.8 0 9.6 0 0-9.6 0-22.4 0-176c0-26.5-21.5-48-48-48L230.5 0c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6zM0 288l0 32c0 35.3 28.7 64 64 64l64 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64l0-64 64 0c35.3 0 64-28.7 64-64l0-32L0 288zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"/></svg>
		),
	},
];

export default function Steps() {
	return (
		<StepsContainer>
			{steps.map((step) => (
				<Step key={step.name}>
					<Link className="step" to={step.route} activeProps={{ className: "step-active" }}>
						{step && step.icon()}
						<p style={type_f} className="step-label">
							{step.name}
						</p>
					</Link>
				</Step>
			))}
		</StepsContainer>
	);
}

const STEP_PADDING = 8;
const STEP_SIZE = 70;

const StepsContainer = styled.div`
	// min-width: ${STEP_SIZE}px;
	// width: ${STEP_SIZE}px;
	background-color: #f0e9e7;
	position: absolute;
	top: 1rem;
	right: 100%;
	border-radius: 5px 0 0 5px;
	overflow: hidden;
	z-index: 100;
`;

const Step = styled.div`
	.step {
		all: unset;
		box-sizing: border-box;
		aspect-ratio: 1 / 1;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		padding-inline: 12px;
		padding-block: 0.75rem;
		flex-direction: column;
		row-gap: 0.5rem;
		color: rgb(189, 176, 172);
		background-color: rgb(226, 219, 217);

		transition:
			background-color 98ms linear,
			color 98ms linear;

		svg {
			width: 18px;
		}
		svg path {
			fill: rgb(189, 176, 172);
			transition: fill 98ms linear;
		}

		.step-label {
			// max-width: calc(100% - ${STEP_PADDING * 2}px);
			white-space: nowrap;
		}

		&:hover:not(.step-active) {
			background-color: rgb(248, 240, 238);
			color: ${({ theme }) => theme.colors.secondary};
			cursor: pointer;

			svg path {
				fill: ${({ theme }) => theme.colors.secondary};
			}
		}

		@media (max-width: ${BREAKPOINTS.mobile}px) {
			height: 100%;
			padding: 0px ${STEP_PADDING}px;

			.step-label {
				max-width: 100%;
			}
		}
	}

	.step-active {
		background-color: #f0e9e7;
		color: ${({ theme }) => theme.colors.secondary};

		svg path {
			fill: ${({ theme }) => theme.colors.secondary};
		}
	}
`;
